if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        console.log('evt.target', evt.target)
        const model = evt.target.closest('.form').querySelector('.product-model')?.value?.replace('*', '');
        const stock = evt.target.closest('.form').querySelector('.product-stock')?.value;
        const scoreStock = calcularScoreStock(evt.target.closest('.form').querySelector('.product-stock')?.value);
        const availableSizes = getAvailableAndUnavailableSizes(evt.target.closest('.form').querySelector('.product-stock')?.value).available;
        const unavailableSizes = getAvailableAndUnavailableSizes(evt.target.closest('.form').querySelector('.product-stock')?.value).unavailable;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }


            console.log('Variante agregada al carrito:', response);
            const item = response;

            setTimeout(() => {
              let itemCategory2 = '';
              const typeOfProduct = item.product_type;
              if (typeOfProduct == 'Anillos' || typeOfProduct == 'Collares' || typeOfProduct == 'Pendientes' || typeOfProduct == 'Pulseras') {
                itemCategory2 = 'Bisutería'
              } else if(typeOfProduct == 'Bolsos' || typeOfProduct == 'Bufandas' || typeOfProduct == 'Calcetines' || typeOfProduct == 'Calzado' || typeOfProduct == 'Cinturones' || typeOfProduct == 'Gafas' || typeOfProduct == 'Gorros' || typeOfProduct == 'Monederos') {
                itemCategory2 = 'Accesorios'
              } else if (typeOfProduct == 'Abrigos' || typeOfProduct == 'Gabardinas') {
                itemCategory2 = 'Abrigos y Gabardinas'
              } else if (typeOfProduct == 'Bañador' || typeOfProduct == 'Baño') {
                itemCategory2 = 'Baño'
              } else if (typeOfProduct == 'Blusas' || typeOfProduct == 'Camisas') {
                itemCategory2 = 'Camisas y Blusas'
              } else if (typeOfProduct == 'Camisetas') {
                itemCategory2 = 'Camisetas'
              } else if (typeOfProduct == 'Chalecos') {
                itemCategory2 = 'Chalecos'
              } else if (typeOfProduct == 'Kimonos' || typeOfProduct == 'Chaquetas') {
                itemCategory2 = 'Chaquetas y Kimonos'
              } else if (typeOfProduct == 'Faldas') {
                itemCategory2 = 'Faldas'
              } else if (typeOfProduct == 'Jerséis' || typeOfProduct == 'Cárdigans' || typeOfProduct == 'Ponchos') {
                itemCategory2 = 'Jerséis y Cárdigans'
              } else if (typeOfProduct == 'Pantalones') {
                itemCategory2 = 'Pantalones'
              } else if (typeOfProduct == 'Sudaderas') {
                itemCategory2 = 'Sudaderas'
              } else if (typeOfProduct == 'Tops') {
                itemCategory2 = 'Tops'
              } else if (typeOfProduct == 'Vaqueros') {
                itemCategory2 = 'Vaqueros'
              } else if (typeOfProduct == 'Vestidos' || typeOfProduct == 'Monos') {
                itemCategory2 == 'Vestidos y Monos'
              }

              let itemCategory = '';
              if(itemCategory2 == 'Accesorios') {
                itemCategory = 'Accesorios';
              } else if (itemCategory2 == 'Bisutería') {
                itemCategory = 'Bisutería'
              } else {
                itemCategory = 'Ropa'
              }

              gtag("event", "add_to_cart", {
                'event': 'add_to_cart',
                'currency': 'EUR',
                'event_category': 'ecommerce',
                'item_list_name': sessionStorage.getItem('item_list_name'),
                'item_list_id': sessionStorage.getItem('item_list_id'),
                items: [
                  {
                    'item_id': item.product_id,
                    'item_name': item.product_title,
                    'quantity': 1,
                    'price': parseFloat(item.price / 100),
                    'discount': parseFloat(item.total_discount / 100) > 0 ? parseFloat(item.total_discount / 100) : 0,
                    'coupon': '',
                    'item_brand': 'renatta&go',
                    'item_category': itemCategory,
                    'item_category2': itemCategory2,
                    'item_category3': item.product_type,
                    'item_variant': item.variant_title.split(' / ')[0],
                    'affiliation': "",
                    'location_id': '',
                    'index': sessionStorage.getItem('index_list'),
                    'item_list_name': sessionStorage.getItem('item_list_name'),
                    'item_list_id': sessionStorage.getItem('item_list_id'),
                    'promotion_name': sessionStorage.getItem('promotion_name') || '',
                    'promotion_id': sessionStorage.getItem('promotion_id') || '',
                    "img_articulo": item.image.split('https://cdn.shopify.com/s/')[1],
                    "color": item.variant_title.split(' / ')[1],
                    "precio_articulo": parseFloat(item.price / 100),
                    "descuento_artículo": parseFloat(item.total_discount / 100) > 0 ? parseFloat(item.total_discount / 100) : 0,
                    "stock": stock,
                    'tallas_disponibles': availableSizes,
                    "tallas_no_disponibles": unavailableSizes,
                    "score_stock": scoreStock,
                    "modelo_artículo": model,
                  }
                ]
              });
            }, 500)
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
